<template>
  <div>
    <div class="grid-content maintitle">
      <span>订单管理</span>
    </div>

    <!-- 导表按钮 -->
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            size="medium"
            round
            @click="refresh"
            icon="el-icon-refresh"
          >
            刷新
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button
            size="medium"
            round
            @click="openUpload"
            icon="el-icon-upload2"
          >
            导入
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button
            size="medium"
            round
            @click="downloadCsv"
            icon="el-icon-download"
          >
            导出
          </el-button>
        </el-link>
      </div>
      <el-divider></el-divider>
    </div>

    <!-- 检索区域 -->
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <!-- <tr>
         
        </tr> -->
        <tr>
          <td>
            <span>orderID:</span>
          </td>
          <td>
            <el-input v-model="editFilter.orderID" size="mini"></el-input>
          </td>

          <td>
            <span>userID:</span>
          </td>
          <td>
            <el-input v-model="editFilter.userID" size="mini"></el-input>
          </td>

          <td>
            <span>openID:</span>
          </td>
          <td>
            <el-input v-model="editFilter.openID" size="mini"></el-input>
          </td>

          <td>
            <span>unionID:</span>
          </td>
          <td>
            <el-input v-model="editFilter.unionID" size="mini"></el-input>
          </td>
          <td>
            <span>收件人姓名:</span>
          </td>
          <td>
            <el-input v-model="editFilter.consignee" size="mini"></el-input>
          </td>

          <td>
            <span>收件人电话:</span>
          </td>
          <td>
            <el-input v-model="editFilter.mobile" size="mini"></el-input>
          </td>
        </tr>
      </table>

      <!-- 完成日期选项设置 -->
      <div style="display: flex; justify-content: space-between; width: 80%">
        <table class="simpleRow">
          <tr>
            <td>
              <span>完成日期:</span>
            </td>
            <td>
              <el-select
                v-model="editFilter.endDate.dateType"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in dateTypeOptions"
                  :key="item.type"
                  :label="item.label"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </td>

            <td
              v-if="
                editFilter.endDate.dateType == 1 ||
                editFilter.endDate.dateType == 3 ||
                editFilter.endDate.dateType == 4 ||
                editFilter.endDate.dateType == 7
              "
            >
              <span v-if="editFilter.endDate.dateType == 7">从</span>
              <el-date-picker
                v-model="editFilter.endDate.fromDate"
                value-format="timestamp"
                type="date"
                size="mini"
                placeholder="选择日期"
              >
              </el-date-picker>
            </td>

            <td v-if="editFilter.endDate.dateType == 7">
              <span>至</span>
              <el-date-picker
                v-model="editFilter.endDate.toDate"
                value-format="timestamp"
                type="date"
                size="mini"
                placeholder="选择日期"
              >
              </el-date-picker>
            </td>

            <td v-if="editFilter.endDate.dateType == 14">
              <span>在</span>
              <el-input-number
                v-model="editFilter.endDate.nowDay"
                :min="1"
                size="mini"
              ></el-input-number>
              <span>天</span>
            </td>
            <td v-if="editFilter.endDate.dateType == 14">
              <el-select v-model="editFilter.endDate.nowType" size="mini">
                <el-option label="以内" :value="0"> </el-option>
                <el-option label="以外" :value="1"> </el-option>
              </el-select>
            </td>
          </tr>
        </table>
        <table class="simpleRow">
          <tr>
            <td>
              <el-button type="primary" @click="onSearch" size="mini"
                >检索</el-button
              >
            </td>
            <td>
              <el-button @click="resetEditFilter" size="mini">清除</el-button>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="grid-content content-margin">
      <!-- <el-table
        :height="tableHeight"
        style="width: 100%"
        :data="orderList"
        row-key="rowKey"
        ref="table"
        :cell-style="rowStyle"
        border
      > -->
      <el-table
        :height="tableHeight"
        style="width: 100%"
        :data="orderList"
        row-key="rowKey"
        :tree-props="{ children: 'details', hasChildren: 'hasChildren' }"
        ref="table"
        :cell-style="rowStyle"
        border
      >
        <el-table-column min-width="30" align="center" width="30" fixed>
        </el-table-column>

        <!-- 订单操作区域 -->
        <el-table-column fixed width="160" label="订单操作">
          <template slot-scope="scope">
            <el-button-group v-if="!scope.row.orderDetailID">
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editOrder(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  deleteRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>

        <el-table-column
          prop="order.orderID"
          label="订单号"
          width="150"
          fixed
          show-overflow-tooltip
        >
        </el-table-column>

        <!-- <el-table-column prop="order.payDate" label="下单付款日期" width="175">
        </el-table-column> -->

        <el-table-column
          prop="order.endDate"
          label="完成日期"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="order.userID"
          label="userID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="order.openID"
          label="openID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="order.unionID"
          label="unionID"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column>

        <!-- <el-table-column
          prop="order.state"
          label="状态"
          width="175"
          show-overflow-tooltip
        >
        </el-table-column> -->

        <!-- <el-table-column label="配送信息"> -->
        <!-- <el-table-column
          prop="order.consignee"
          label="收货人姓名"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="order.mobile"
          label="电话"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column label="收货地址"> -->
        <!-- <el-table-column
          prop="order.province"
          label="省"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="order.address"
          label="详细地址"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column
          prop="order.zipcode"
          label="邮编"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <!-- </el-table-column> -->
        <!-- </el-table-column> -->

        <!-- <el-table-column
          prop="orderDetailID"
          label="订单详情id"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="commodityID"
          label="商品ID"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="数量"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="serialNo"
          label="产品序列号"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="qualityGuarantee"
          label="保障期限"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>

        <!-- 详情操作区 -->
        <!-- <el-table-column width="80" label="删除详情" align="center">
          <template slot-scope="scope">
            <el-button-group v-if="scope.row.orderDetailID">
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  deleteRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页组件 -->
      <pagination
        :pagesizeList="pageConfig.pagesizeList"
        :pagesize="sendData.pageConfig.pagesize"
        :total="pageConfig.total"
        :page="sendData.pageConfig.page"
      ></pagination>
    </div>

    <!-- 订单导入对话框 -->
    <el-dialog
      :show-close="false"
      :size="600"
      :visible.sync="showUploadOrder"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>导入订单</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showUploadOrder = false"
            >
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>

      <div class="grid-content content-margin">
        <table class="simpleRow">
          <!-- 类型选择 -->
          <tr>
            <div>
              <span>字段转换分组:</span>
            </div>

            <div>
              <el-select
                v-model="uploadData.fieldgroupid"
                placeholder="无字段转换分组"
                size="small"
                style="width: 200px"
              >
                <el-option
                  v-for="item in fieldGroupOption"
                  :key="item.groupid"
                  :label="item.name"
                  :value="item.groupid"
                >
                </el-option>
              </el-select>
            </div>
          </tr>
        </table>
      </div>
      <div class="grid-content content-margin">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="/manage/order/importorderlist"
          :headers="sessionHeaders"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :auto-upload="false"
          :data="uploadData"
          :on-success="handleSuccess"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="small"
            type="success"
            @click="submitUpload"
            >上传到服务器</el-button
          >
          <div slot="tip" class="el-upload__tip">只能上传csv文件</div>
        </el-upload>
      </div>
    </el-dialog>

    <!-- 删除确认框 -->
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>请确认是否删除该内容(删除订单将删除其下所有订单详情)</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 编辑订单绑定用户 -->
    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showDateilDrawer"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>修改订单绑定的用户</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <!-- 订单号 -->
          <tr>
            <div>
              <span>订单号</span>
            </div>
            <div>
              <el-input
                v-model="editOrderID"
                placeholder="请输入内容"
                size="small"
                :disabled="true"
                style="width: 500px"
              ></el-input>
            </div>
          </tr>

          <tr>
            <div>
              <span>绑定用户</span>
            </div>
            <div>
              <el-input
                v-model="editUserID"
                placeholder="请输入内容"
                size="small"
                style="width: 500px"
              ></el-input>
            </div>
          </tr>
        </table>
      </div>
    </el-drawer>
    <a :href="url" style="display: none" ref="aclick"></a>
  </div>
</template>

<script>
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import commonUtil from "@/utils/commonUtil";
export default {
  name: "Order",
  data() {
    return {
      tableHeight: 500,
      showUploadOrder: false,
      fileList: [],
      uploadData: { appid: 188, fieldgroupid: 0 },
      fieldGroupOption: [],

      //   发送的数据
      sendData: {
        appID: 188,
        filterConfig: {},
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },

      // 分页
      pageConfig: {
        pagesizeList: [5, 20, 50, 100],
        total: null,
      },

      editFilter: {},

      //服务器返回订单列表
      orderList: [],

      deleteRow: null,
      deleteDialogVisible: false,
      showDateilDrawer: false,

      editUserID: String,
      editOrderID: String,

      url: "",
      name: "",

      dateTypeOptions: [
        { label: "不启用", type: 0 },
        { label: "等于", type: 1 },
        { label: "大于", type: 3 },
        { label: "小于", type: 4 },
        { label: "区间", type: 7 },
        { label: "当前时间点", type: 14 },
      ],
    };
  },
  watch: {},
  methods: {
    downloadCsv() {
      rejecthttp(
        true,
        "post",
        "/manage/order/exportorderlist",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.name = doc.data.data;
            this.url = "/rs/exportdownload/bigcsv?handlekey=" + doc.data.data;
            console.log("aaaaaaaaa", this.url);
            this.openCsv(this.url);
          }
        }
      );
    },

    openCsv(url) {
      this.$confirm("文件导出完成", "提示", {
        confirmButtonText: "下载",
        cancelButtonText: "取消",

        type: "info",
      })
        .then(() => {
          this.$refs.aclick.click();
          this.$message({
            type: "success",
            message: "正在下载!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },

    resetEditFilter() {
      this.editFilter = {
        endDate: {
          dateType: 0,
          fromDate: "",
          nowDay: 1,
          nowType: 0,
          toDate: "",
        },
        orderID: "",
        userID: "",
        openID: "",
        unionID: "",
        state: -1,
        address: "",
        mobile: "",
        consignee: "",
        orderDetailID: "",
        serialNo: "",
        quantity: 0,
        commodityName: "",
      };

      this.onSearch();
    },

    onSearch() {
      this.pageConfig.total = null;
      this.sendData.filterConfig = JSON.parse(JSON.stringify(this.editFilter));
      this.refresh();
    },

    doSaveDetail() {
      rejecthttp(
        true,
        "get",
        "/manage/order/updateorderuser",
        {
          appid: this.sendData.appID,
          orderid: this.editOrderID,
          orderuserid: this.editUserID,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.showDateilDrawer = false;
            this.refresh();
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    editOrder(row) {
      this.showDateilDrawer = true;
      this.editUserID = row.order.userID;
      this.editOrderID = row.order.orderID;
    },

    deleteTarget() {
      this.deleteDialogVisible = false;

      //删除详情
      if (this.deleteRow.orderDetailID) {
        rejecthttp(
          true,
          "get",
          "/manage/order/delorderdetail",
          {
            appid: this.sendData.appID,
            orderdetailid: this.deleteRow.orderDetailID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.refresh();
              this.$message({
                type: "success",
                message: doc.data.Message,
              });
            } else {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            }
          }
        );
      }
      //删除订单
      else if (this.deleteRow.order) {
        rejecthttp(
          true,
          "get",
          "/manage/order/delorder",
          {
            appid: this.sendData.appID,
            orderid: this.deleteRow.order.orderID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.refresh();
              this.$message({
                type: "success",
                message: doc.data.Message,
              });
            } else {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            }
          }
        );
      }
    },

    rowStyle({ row, column, rowIndex, columnIndex }) {
      //设置表格每行间隔颜色
      if (columnIndex < 12) {
        return { background: "#FAFAFA", border: "none", color: "#111" };
      }
      if (row.order) {
        return { background: "#FAFAFA", border: "none", color: "#111" };
      }
      if (row.orderDetailID) {
        return { background: "#F0F5FC", color: "#111" };
      }
    },

    openUpload() {
      this.showUploadOrder = true;

      //获取字段转换分组列表
      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/getgrouplist",
        {
          appid: this.uploadData.appid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.fieldGroupOption = doc.data.data;
            this.$set(this.fieldGroupOption, this.fieldGroupOption.length, {
              name: "无",
              groupid: 0,
              appid: 188,
            });

            if (this.fieldGroupOption.length > 0) {
              this.uploadData.fieldgroupid = this.fieldGroupOption[0].groupid;
            }

            console.log(this.fieldGroupOption);
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    handleClose(done) {},

    submitUpload() {
      if (this.uploadData.fieldgroupid == 0) {
        this.$message({
          type: "error",
          message: "请选择字段转换分组",
        });
        return;
      }

      this.$refs.upload.submit();
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    handlePreview(file) {
      console.log(file);
    },

    refresh() {
      rejecthttp(
        true,
        "post",
        "/manage/order/getorderlist",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.orderList = doc.data.data;

            this.orderList.forEach((any) => {
              any.rowKey = any.order.orderID;
              any.order.endDate = commonUtil.formatDate(any.order.endDate);
              any.order.payDate = commonUtil.formatDate(any.order.payDate);

              any.details.forEach((detail) => {
                detail.rowKey = detail.orderID + "_" + detail.orderDetailID;
                detail.qualityGuarantee = commonUtil.formatDate(
                  detail.qualityGuarantee
                );
              });
            });

            console.log(this.orderList);
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );

      if (this.pageConfig.total != null) {
        return;
      }

      rejecthttp(
        true,
        "post",
        "/manage/order/getorderlistcount",
        this.sendData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.pageConfig.total = doc.data.data;
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    paginationChange(pagesize, page, name) {
      this.sendData.pageConfig.page =
        page != -1 ? page : this.sendData.pageConfig.page;
      this.sendData.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
      this.refresh();
    },

    handleSuccess(res, file) {
      console.log(res);
      this.showUploadOrder = false;

      if (res.Code == "MSGKEY_OK") {
        this.refresh();
        this.$message({
          type: "success",
          message: res.Message,
        });
      } else {
        this.$message({
          type: "error",
          message: res.Message,
        });
      }

      this.fileList = [];
    },
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;
      console.log(this.tableHeight);

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },

  computed: {
    sessionHeaders() {
      return { dmfsession: this.$store.state.DMFSession };
    },
  },
  created() {
    this.resetEditFilter();
  },
  components: {
    pagination,
  },
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/order/order.vue